import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import WelcomeView from "@/views/WelcomeView.vue";
import InteractiveView from "@/views/Interactive/InteractiveView.vue";
//import ExperienceWorld from "../components/ExperienceWorld.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: WelcomeView,
  },
  {
    path: "/interactive",
    name: "interactive",
    component: InteractiveView,
    redirect: "/interactive/desktop",
    children: [
      {
        path: "desktop",
        name: "desktop",
        component: () => import("@/views/Interactive/DesktopView.vue"),
      },
      {
        path: "mobile",
        name: "mobile",
        component: () => import("@/views/Interactive/MobileView.vue"),
      },
      {
        path: "tablet",
        name: "tablet",
        component: () => import("@/views/Interactive/TabletView.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to);
  if (to.path == "/experience/simulation" ||to.path == "/interactive/desktop") {
    store.commit("setInExperience", true);
    console.log("inside simulation");
    document.querySelector("body").classList.remove("night");
    console.log("simulation", document.querySelector("body").classList);
  } else {
    console.log("out of simulation");
    store.commit("setInExperience", false);

    if (!document.querySelector("body").classList.contains("night")) {
      document.querySelector("body").classList.add("night");
    }
  }

  next();
  // ...
  // explicitly return false to cancel the navigation
  //return true;
});

export default router;
